import { validateEmail } from "./validate-email";
import { validateLatitude, validateLongitude } from "./validate-location";
import { validatePassword } from "./validate-password";
import { validatePhoneNumber } from "./validate-phone";
import { validateMultiplePhoneNumbers } from "./validate-phone/validate-multiple-phones";
import { validateUrl } from "./validate-url";

export const Validations = {
  validateEmail,
  validatePhoneNumber,
  validateMultiplePhoneNumbers,
  validatePassword,
  validateLatitude,
  validateLongitude,
  validateUrl,
};
